import { useNavigate } from "react-router-dom";
import { paths } from "../../../config/paths";
import { UniversalProfilerPage } from "../../../features/profiler/components/UniversalProfilerPage";

export const BeautyProfilerProfiler = () => {
    const navigate = useNavigate();

  const handleBack = () => {
    navigate(paths.app.path);
  };

  return (
    <UniversalProfilerPage
      profiler="beauty-profiler"
      subtitle="Your Christian Louboutin Allure"
      onBack={handleBack}
    />
  );
};
